<template>
    <div class="app">
        <scroll v-pull="refresh">
            <section class="field-box">
                <dl class="field">
                    <dt>就诊序号</dt>
                    <dd class="f-strong">{{visitInfoDetail.index | formatNum}}</dd>
                </dl>
            </section>
            <section class="field-box">
                <dl class="field">
                    <dt>就诊时间</dt>
                    <dd>{{visitInfoDetail.treatDate | formatDate}}</dd>
                </dl>
                <dl class="field">
                    <dt>就诊医院</dt>
                    <dd>{{visitInfoDetail.hospital}}</dd>
                </dl>
                <dl class="field">
                    <dt>就诊类型</dt>
                    <dd>{{visitInfoDetail.treatType}}</dd>
                </dl>
                <dl class="field">
                    <dt>就诊科室</dt>
                    <dd>{{visitInfoDetail.deptName}}</dd>
                </dl>
                <dl class="field">
                    <dt>主治医生</dt>
                    <dd>{{visitInfoDetail.doctName}}</dd>
                </dl>
                <dl class="field">
                    <dt>主诉</dt>
                    <dd>{{visitInfoDetail.chiefComplaint}}</dd>
                </dl>
                <dl class="field">
                    <dt>诊断名称</dt>
                    <dd>{{visitInfoDetail.treatName}}</dd>
                </dl>
            </section>
            <div v-for="(drugItem, index) in medInfo.drugItems">
                <section class="thick">
                    <div class="title" @click="showDetail(drugItem)">
                        <span class="f-strong">药品序号 {{(index + 1) | formatNum}}</span>
                        <div style="display: inline-block; float: right; padding-right: 1rem;">
                            <span v-if="drugItem.showDetailInfo" class="arr-gray-down"></span>
                            <span v-if="!drugItem.showDetailInfo" class="arr-gray-up"></span>
                        </div>
                    </div>
                    <div v-show="!drugItem.showDetailInfo">
                        <div class="report-detail">
                            <div class="field" style="background: #f8f8f8">
                                <div>
                                    <label>{{drugItem.drugName}}</label>
                                    <label class="f-minor">（{{drugItem.frequency}}）</label>
                                </div>
                            </div>
                            <div class="report-table-container">
                                <table class="report-table">
                                    <tr>
                                        <td class="f-minor">发药量</td>
                                        <td class="f-minor">用药量</td>
                                        <td class="f-minor">用药频次</td>
                                    </tr>
                                    <tr>
                                        <td>{{drugItem.grantDose}}</td>
                                        <td>{{drugItem.dosage}}</td>
                                        <td>{{drugItem.frequency}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </scroll>
    </div>
</template>
<script>
import recordService from 'record.service'
export default {
    data() {
        return {
            visitInfoDetail: {
//                "treatDate": "2017-11-12 20:20:20",
//                "hospital": "彭州市人民医院",
//                "treatType": "门诊",
//                "deptName": "呼吸科",
//                "doctName": "张医师",
//                "chiefComplaint": "咳嗽",
//                "treatName": "咽喉炎",
//                "treatId": "201601010005"
            },
            medInfo: {
                "totalNum": 0,
                "drugItems": [
//                    {
//                        "drugName": "阿莫西林",
//                        "drugUsage": "口服",
//                        "grantDose": "1盒",
//                        "dosage": "1粒",
//                        "frequency": "1 天 2 次",
//                        "showDetailInfo": false,
//                    },
//                    {
//                        "drugName": "阿莫西林2",
//                        "drugUsage": "口服2",
//                        "grantDose": "2盒",
//                        "dosage": "2粒",
//                        "frequency": "1 天 3 次",
//                        "showDetailInfo": false,
//                    }
                ]
            },
            curPage: 1
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.visitInfoDetail = this.$store.state.paramModule.param.healthRecord.treatItem;
            var voucher = this.$store.state.paramModule.param.healthRecord.voucher;
            recordService.getMedHistory(
            {
                cardNo: voucher.cardNo,
                cardType: voucher.cardType,
                curPage: this.curPage,
                treatId: this.visitInfoDetail.treatId
            }).then((res) => {
                if (res.drugItems.length > 0) {
                    for (var i = 0; i < res.drugItems.length; i++) {
                        res.drugItems[i].showDetailInfo = false;
                    }
                    this.medInfo.drugItems = this.medInfo.drugItems.concat(res.drugItems);
                    this.curPage = this.curPage + 1;
                }
            });
        },
        showDetail(drugItem) {
            drugItem.showDetailInfo = !drugItem.showDetailInfo;
        },
    }
}
</script>


// WEBPACK FOOTER //
// VisitRecordDetail.vue?2c40d7d2